import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import APModal from 'components/Modal/APModal';
import { copyToClipboard } from 'utils/general';

import './styles.scss';


const GetLinkModal = ({ open, link, onClose }) => {
  const [isLinkCopied, setLinkCopied] = React.useState(false);

  React.useEffect(() => {
    if (!open) setLinkCopied(false);
  }, [open]);

  return (
    <APModal
      open={open}
      title=""
      name="link-modal"
      className={clsx('link_modal', 'link_modal__container')}
      onClose={onClose}
      actions={null}
    >
      <section className="link_modal__body link_modal__content">
        <span className="link_modal__content-title">Link</span>
        <input
          id="submissionLink"
          className="link_modal__input"
          defaultValue={link}
          type="text"
          placeholder="www.website.com/123456789"
        />
        <button
          className="link_modal__submit"
          onClick={() => {
            copyToClipboard(link);
            setLinkCopied(true);
          }}
        >
          {!isLinkCopied ? (
            'Copy'
          ) : (
            <i
              className="fal fa-check"
              aria-hidden="true"
              style={{ fontSize: 14 }}
            />
          )}
        </button>
        <span className="link_modal__content-copied">
          {isLinkCopied && 'Copied to clipboard'}
        </span>
      </section>
    </APModal>
  );
};

GetLinkModal.propTypes = {
  onClose: PropTypes.func,
};

GetLinkModal.defaultProps = {};

export default GetLinkModal;
